// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"5b2c03cd","169":"23358259"}[chunkId] + ".css";
};